/* eslint-disable no-undef */
import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// Type for Sanity image source
type SanityImageSource = {
  _type?: string;
  asset?: { _ref?: string; _type?: string };
  [key: string]: unknown;
};

// Two separate Sanity projects:
// Production: piwc2ip3 (main branch)
// Dev: tpp36u0t (dev branch)
const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || 'piwc2ip3';
const dataset = 'production'; // Always use production dataset in both projects
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-01-01';

// Read-only client (for fetching data)
// useCdn: false to get fresh data with revalidation
export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
});

// Write client (for form submissions - server-side only)
export const writeClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  token: process.env.SANITY_API_WRITE_TOKEN,
});

// Image URL builder
const builder = imageUrlBuilder(client);

export function urlFor(source: SanityImageSource) {
  return builder.image(source);
}
